enum CustomApiBuildInFieldName {
  SourceUrl = 'api.label.sourceUrl',
  OperationId = 'operationId',
  CodeSample = 'api.label.sampleCode',
}

export const CustomApiBuiltInField = {
  BASE_URL: 'baseUrl',
  OWNER: 'owner',
  UPDATE_TIME: 'updateTime',
  OPERATION_ID: CustomApiBuildInFieldName.OperationId,
  SOURCE_URL: CustomApiBuildInFieldName.SourceUrl,
  CODE_SAMPLE: CustomApiBuildInFieldName.CodeSample,
} as const;
